











































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { BuildQuestion } from '@/utils/add-question/add-question-util';
import { Chapter } from '@/resource/question/question.model';
import { Subject } from '@/resource/subject/subject.model';
import getLevel from '@/utils/common/get-level';

@Component({})
export default class BuildSubject extends Vue {
  @Prop()
  buildQuestion!: BuildQuestion;

  @Prop()
  availSubjects!: Subject[];

  isFirstLoadSubject = true;
  isFirstLoadForm = true;
  isFirstLoadChapter = true;

  selectedSubject = '';
  selectedForm = '';
  selectedChapter = '';

  get selectedSubjectObject(): Subject | null {
    let subject: Subject | null = null;
    const selectedSubject = this.availSubjects.find(
      subject => subject.name === this.selectedSubject,
    );

    if (selectedSubject) {
      subject = selectedSubject;
    }

    return subject;
  }

  get availForms(): string[] {
    return [...Array(11).keys()].map(i => this.generateLevel(i + 1));
  }

  get availChapters(): Chapter[] {
    let chapters: Chapter[] = [];
    if (this.buildQuestion && this.selectedSubjectObject) {
      const levelNumber = this.getLevel(this.selectedForm);
      chapters = this.selectedSubjectObject.chapters.filter(
        chapter => chapter.form === levelNumber,
      );
    }

    return chapters;
  }

  created() {
    this.isFirstLoadSubject = true;
    this.isFirstLoadForm = true;
    this.isFirstLoadChapter = true;

    if (this.buildQuestion && this.availSubjects) {
      const selectedChapter = this.buildQuestion.buildChapter;

      this.selectedForm = this.generateLevel(selectedChapter.form);
      this.selectedChapter = this.generateChapter(selectedChapter);
      this.selectedSubject = selectedChapter.subject.name;
    }
  }

  @Watch('selectedSubject')
  subjectChange() {
    if (this.isFirstLoadSubject) {
      this.isFirstLoadSubject = false;
      return;
    }

    if (this.availChapters.length) {
      this.selectedForm = this.generateLevel(this.availChapters[0].form);
      this.selectedChapter = this.generateChapter(this.availChapters[0]);
    }
  }

  @Watch('selectedForm')
  formChange() {
    if (this.isFirstLoadForm) {
      this.isFirstLoadForm = false;
      return;
    }

    if (this.availChapters.length) {
      this.selectedChapter = this.generateChapter(this.availChapters[0]);
    }
  }

  @Watch('selectedChapter')
  chapterChange() {
    if (this.isFirstLoadChapter) {
      this.isFirstLoadChapter = false;
      return;
    }
    const chapter = this.availChapters.find(
      chapter => chapter.name === this.getChapterName(this.selectedChapter),
    );

    if (chapter) {
      this.buildQuestion.buildChapter = chapter;
    }
  }

  generateLevel(level: number) {
    return getLevel(level);
  }

  getLevel(level: string) {
    const [levelType, levelNumber] = level.split(' ');

    if (levelType.trim() === 'Form') {
      return Number(levelNumber.trim()) + 6;
    } else {
      return Number(levelNumber.trim());
    }
  }

  generateChapter(chapter: Chapter) {
    return `${chapter.name} - (chapter ${chapter.prefix})`;
  }

  getChapterName(generateChapterName: string) {
    return generateChapterName.split('-')[0].trim();
  }

  generateSelectedChapter(chapter: Chapter) {
    const subject = chapter.subject;
    const level = getLevel(chapter.form);

    return `${chapter.name} (chapter ${chapter.prefix}) - ${subject.name}, ${level}`;
  }
}
